import React, {useState} from "react"
import {injectIntl, defineMessages} from "react-intl"
import {Intl} from "../../../state/helpers/IntlProps"
import {getActiveMatrixAxes} from "../../../state/product/ProductSelectors"
import {useDispatch, useSelector} from "react-redux"
import StandardList from "../../../common/listing/list.component"
import {Row} from "../../../common/listing/ListingTypes"
import {initialMatrixAxisState, MatrixAxis} from "../../../state/product/matrix/Matrix"
import Icon from "../../../common/icon/icon.component"
import {deleteMatrixAxis, updateMatrixAxis} from "../../../state/product/ProductActions"
import EditMatrixAxisOptionModal from "../modal/EditMatrixAxisOptionModal"
import MatrixAxisOptionRowComponent from "../component/MatrixAxisOptionRowComponent"
import produce from "immer"
import {MATRIX_AXIS_POSITIONS} from "../../../state/product/Constants"

const messages = defineMessages({
    header: {
        id: "product.variant.component.variant_axis_component_wrapper.title",
        defaultMessage: "Options"
    },
    add_option: {
        id: "product.variant.component.variant_axis_component_wrapper.add_option",
        defaultMessage: "Add an option"
    }
})

type Props = {
    intl: Intl
}

const MatrixAxisSection = (props: Props) => {
    const [modal, setModal] = useState(<></>)
    const axes = useSelector(getActiveMatrixAxes)
    const dispatch = useDispatch()

    const rows: Row<MatrixAxis>[] = axes.map(a => {
        return {
            rowId: a.name,
            data:
                [
                    <MatrixAxisOptionRowComponent key={0} axis={a}/>,
                    <a
                        key={1}
                        className={"float-right text-primary"}
                        onClick={e => {
                            e.preventDefault()
                            setModal(
                                <EditMatrixAxisOptionModal
                                    axis={a}
                                    onUpdateCallback={(axis: MatrixAxis) => {
                                        dispatch(updateMatrixAxis(axis))
                                        setModal(<></>)
                                    }}
                                    onCloseCallback={() => {
                                        setModal(<></>)
                                    }}
                                    onDeleteCallback={() => {
                                        dispatch(deleteMatrixAxis(a.type))
                                        setModal(<></>)
                                    }}
                                />)
                        }}>
                        <Icon value={"edit"}/>
                    </a>
                ],
            metadata: a
        }
    })

    const footer = axes.length < MATRIX_AXIS_POSITIONS.length &&
        <a href={"#"}
            className={"ml-3"}
            onClick={e => {
                e.preventDefault()
                setModal(
                    <EditMatrixAxisOptionModal
                        axis={produce(initialMatrixAxisState, draft => {
                            draft.type = MATRIX_AXIS_POSITIONS[axes.length]
                        })}
                        onUpdateCallback={(axis: MatrixAxis) => {
                            dispatch(updateMatrixAxis(axis))
                            setModal(<></>)
                        }}
                        onCloseCallback={() => {
                            setModal(<></>)
                        }}
                    />)
            }}>
            {props.intl.formatMessage(messages["add_option"])}
        </a>


    return (
        <>
            {modal}
            <StandardList
                className={"p-0"}
                sortable={false} //todo update axis rank
                headers={[props.intl.formatMessage(messages["header"]), ""]}
                rows={rows}
                footer={footer}
                smallLine={true}>
            </StandardList>
        </>
    )
}


export default injectIntl(MatrixAxisSection)


// WEBPACK FOOTER //
// ./src/product/variant/section/MatrixAxisSection.tsx